import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShoppingCart, ArrowRight } from 'lucide-react';
import { useCart } from '../contexts/CartContext';

/**
 * Persistent bottom-right "View cart" pill, only rendered when there's a
 * cart with items AND we are NOT already on the /cart page. Keeps the
 * customer one click away from checkout no matter where they are.
 */
export const FloatingCartButton = () => {
  const { itemCount, total } = useCart();
  const { pathname } = useLocation();

  if (itemCount === 0 || pathname === '/cart') return null;

  return (
    <Link
      to="/cart"
      className="fixed bottom-6 right-6 z-40 flex items-center space-x-3 px-5 py-3 rounded-full font-semibold text-sm shadow-2xl group transition-transform hover:scale-[1.03] active:scale-[0.97]"
      style={{
        background: '#39FF14',
        color: '#0F1113',
        boxShadow: '0 12px 30px -8px rgba(57, 255, 20, 0.6), 0 4px 12px rgba(0,0,0,0.6)',
      }}
      data-testid="floating-cart-button"
      aria-label={`View cart, ${itemCount} item${itemCount === 1 ? '' : 's'}, total $${total.toFixed(2)}`}
    >
      <div className="relative">
        <ShoppingCart className="w-5 h-5" />
        <span
          className="absolute -top-2 -right-2 min-w-[18px] h-[18px] px-1 rounded-full text-[10px] font-bold flex items-center justify-center bg-[#0F1113] text-[#39FF14] border border-[#39FF14]"
          data-testid="floating-cart-count"
        >
          {itemCount}
        </span>
      </div>
      <span data-testid="floating-cart-total">View cart · ${total.toFixed(2)}</span>
      <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
    </Link>
  );
};

export default FloatingCartButton;
